import { useEffect } from 'preact/hooks'
import { useCart } from 'apps/vtex/hooks/useCart.ts'

export default function TolstoyCartListener() {
	const { addItems } = useCart()

	useEffect(() => {
		console.log('[Tolstoy] useEffect iniciado')

		const addToCartCallback = async (payload: any) => {
			console.log('[Tolstoy] addToCartCallback iniciado com payload:', payload)

			const { productId, seller = '1', quantity = 1 } = payload

			if (!productId) {
				console.warn('[Tolstoy] productId ausente no payload')
				return
			}

			try {
				const result = await addItems({
					orderItems: [
						{
							id: productId,
							seller,
							quantity,
						},
					],
				})

				console.log('[Tolstoy] Resultado do addItems:', result)

				window.tolstoyWidget?.postMessage({
					...payload,
					eventName: 'tolstoy_add_to_cart_success',
				})
				console.log('[Tolstoy] Evento de sucesso enviado ao widget')
			} catch (error) {
				console.error('[Tolstoy] Erro ao adicionar ao carrinho:', error)

				window.tolstoyWidget?.postMessage({
					...payload,
					eventName: 'tolstoy_add_to_cart_error',
					description: 'itemSoldOut',
				})
				console.log('[Tolstoy] Evento de erro enviado ao widget')
			}

			console.log('[Tolstoy] addToCartCallback finalizado')
		}

		const subscribeToTolstoyAddToCart = () => {
			window.tolstoyWidget.subscribe('tolstoy_add_to_cart', addToCartCallback)
		}

		if (window.tolstoyWidget) {
			subscribeToTolstoyAddToCart()
		} else {
			window.addEventListener('tolstoyWidgetReady', () => {
				subscribeToTolstoyAddToCart()
			})
		}

		return () => {
			if (window.tolstoyWidget) {
				window.tolstoyWidget.unsubscribe(
					'tolstoy_add_to_cart',
					addToCartCallback,
				)
			}
		}
	}, [addItems])

	return null
}
